
import { useNavigate } from "react-router-dom";


export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function getDayMonthTimePretty(dateString){

  if(dateString === undefined)return "(?)";

    // Ensure JavaScript can parse it: strip microseconds (JS supports max 3 decimals)
    const sanitized = dateString.replace(/\.\d+$/, "");

    const date = new Date(sanitized);

    const day = date.getDate();
    const monthName = date.toLocaleString("da-DK", { month: "long" });
    const time = date.toLocaleString("da-DK", {
      hour: "2-digit",
      minute: "2-digit",
    });

  return `${day}. ${monthName} ${time}`;
};

export function getDayMonthPretty(dateString){

  if(dateString === undefined)return "(?)";

    // Ensure JavaScript can parse it: strip microseconds (JS supports max 3 decimals)
    const sanitized = dateString.replace(/\.\d+$/, "");

    const date = new Date(sanitized);

    const day = date.getDate();
    const monthName = date.toLocaleString("da-DK", { month: "long" });

  return `${day}. ${monthName}`;
};